import { capitalize } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import 'typeface-nunito';
import 'typeface-nunito-sans';
import 'typeface-poppins';

/* eslint-disable */
export const customTheme = createTheme({
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
    unit: 'px',
  },
  direction: 'ltr',
  components: {
    // MuiLinearProgress: {
    //   defaultProps: {
    //     style: {
    //       width: "100%",
    //     },
    //     sx: {
    //       width: "100%"
    //     }
    //   },
    //   styleOverrides: {
    //     root: {
    //       width: "100%",
    //     }
    //   }
    // },
    // MuiAlert: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 24,
    //       alignSelf: 'center',
    //       marginTop: 24,
    //       background: '#FFFFFF',
    //       boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
    //       zIndex: 2,
    //       padding: 24,
    //     },
    //     message: {
    //       fontFamily: 'Nunito',
    //       fontStyle: 'normal',
    //       fontWeight: 800,
    //       fontSize: 16,
    //       lineHeight: '22px',
    //       letterSpacing: '0.2px',
    //       color: '#000000',
    //       overflow: 'hidden',
    //     },
    //     action: {
    //       '.MuiSvgIcon-root': {
    //         fill: '#D9D9D9',
    //       },
    //       '.css-jjsrqu-MuiButtonBase-root-MuiIconButton-root:hover': {
    //         backgroundColor: 'unset',
    //       },
    //     },
    //   },
    // },
    MuiMobileStepper: {
      // defaultProps: {
      //   style: {
      //     width: "100%",
      //   },
      //   sx: {
      //     width: "100%",
      //   }
      // },
      styleOverrides: {
        // root: {
        //   width: "100%"
        // },
        progress: {
          width: '100%',
          top: '0vh',
          position: 'fixed',
          height: '8px',
          left: '0px',
        },
      },
    },
    MuiButton: {
      defaultProps: {},
      styleOverrides: {
        root: {
          borderRadius: 24,
        },
        contained: {
          borderRadius: 24,
        },
        containedPrimary: {
          borderRadius: 24,
        },
        containedSecondary: {
          borderRadius: 24,
        },
        outlined: {
          borderRadius: 24,
        },
        outlinedPrimary: {
          borderRadius: 24,
        },
        outlinedSecondary: {
          borderRadius: 24,
        },
        text: {
          borderRadius: 24,
        },
      },
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#ff8521',
      light: '#ffb654',
      dark: '#c3681d',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1a1464',
      light: '#4d3b93',
      dark: '#000039',
      contrastText: '#ffffff',
    },
    common: {
      black: '#000',
      white: '#fff',
    },
    error: {
      main: 'rgba(244, 67, 54, 1)',
      light: 'rgba(248, 128, 120, 1)',
      dark: 'rgba(227, 27, 12, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    warning: {
      main: '#DBCB05',
      light: '#FFF66A',
      dark: '#B7A803',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    info: {
      main: 'rgba(33, 150, 243, 1)',
      light: 'rgba(100, 182, 247, 1)',
      dark: 'rgba(11, 121, 208, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    success: {
      main: 'rgba(76, 175, 80, 1)',
      light: 'rgba(123, 198, 126, 1)',
      dark: 'rgba(59, 135, 62, 1)',
      contrastText: 'rgba(255, 255, 255, 1)',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#f5f5f5',
      A200: '#eeeeee',
      A400: '#bdbdbd',
      A700: '#616161',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
      paper: '#fff',
      default: '#fff',
    },
    action: {
      active: '#ff8521',
      hover: '#ff8521',
      hoverOpacity: 0.25,
      selected: '#ff8521',
      selectedOpacity: 0.08,
      // disabled: "rgba(0, 0, 0, 0.26)",
      disabled: '#666666',
      // disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledBackground: 'rgba(212,211,211,1)',
      disabledOpacity: 0.38,
      focus: '#ff8521',
      focusOpacity: 0.12,
      activatedOpacity: 0.12,
    },
  },
  shape: {
    borderRadius: 4,
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48,
      },
      '@media (min-width:600px)': {
        minHeight: 64,
      },
    },
  },
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 4px 10px 0px rgba(255,133,33,0.55),0px 4px 10px 0px rgba(0,0,0,0),0px 4px 10px 0px rgba(0,0,0,0)', // Button active Shadows
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  typography: {
    htmlFontSize: 16,
    fontFamily: '"Nunito Sans","Poppins"',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: '"Nunito Sans","Poppins"',
      fontWeight: 300,
      fontSize: '6rem',
      lineHeight: 1.167,
      letterSpacing: '-0.01562em',
    },
    h2: {
      fontFamily: '"Nunito Sans","Poppins"',
      fontWeight: 300,
      fontSize: '3.75rem',
      lineHeight: 1.2,
      letterSpacing: '-0.00833em',
    },
    h3: {
      fontFamily: '"Nunito"',
      fontStyle: 'normal',
      fontWeight: 800,
      fontSize: '34px',
      lineHeight: 1.2,
      letterSpacing: '0em',
      textTransform: 'capitalize',
    },
    h4: {
      fontFamily: '"Nunito Sans","Poppins"',
      fontWeight: 400,
      fontSize: '2.125rem',
      lineHeight: 1.235,
      letterSpacing: '0.00735em',
    },
    h5: {
      fontFamily: '"Poppins"',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: 1.334,
      letterSpacing: '0px',
    },
    h6: {
      fontFamily: '"Poppins"',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: 1.6,
      letterSpacing: '0.15px',
    },
    subtitle1: {
      fontFamily: '"Poppins"',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '22px',
      lineHeight: 1.64,
      letterSpacing: '0.15%',
    },
    subtitle2: {
      fontFamily: '"Poppins"',
      fontWeight: 700,
      fontSize: '19px',
      lineHeight: 1.2,
      letterSpacing: '0.01px',
      textTransform: 'capitalize',
    },
    body1: {
      fontFamily: '"Nunito Sans"',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: 1.5,
      letterSpacing: '0.15px',
    },
    body2: {
      fontFamily: '"Nunito Sans"',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: 1.43,
      letterSpacing: '0.15px',
    },
    button: {
      fontFamily: '"Nunito Sans"',
      fontWeight: 600,
      fontSize: '15px',
      lineHeight: 1.75,
      letterSpacing: '0.46px',
      textTransform: 'capitalize',
    },
    caption: {
      fontFamily: '"Nunito Sans"',
      color: 'rgba(0, 0, 0, 0.6)',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: 1.66,
      letterSpacing: '0.4px',
    },
    overline: {
      fontFamily: '"Nunito Sans","Poppins"',
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 2.66,
      letterSpacing: '0.08333em',
      textTransform: 'uppercase',
    },
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
});
/* eslint-enable */
